import * as React from 'react';
import Typography from '@mui/material/Typography';
import { NormalButton } from 'components/atoms/Button';
import { styled } from '@mui/material/styles';
import { Avatar, AvatarGroup, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import SuperScriptStr from 'components/atoms/String/SuperScriptStr';
import PlayArrow from '@mui/icons-material/PlayArrow';

const CustomCardContent = styled(CardContent)(({ theme }) => ({
  position: 'absolute',
  bottom: '0px',
  left: '0px',
  padding: '1.3rem',
  boxSizing: 'border-box',
  minHeight: '30%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'transparent',
  borderRadius: '20px',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '2rem',
  fontWeight: 'bold',
  width: '100%',
}));

const ParaText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '1rem',
  fontWeight: 'lighter',
  margin: '20px 0px',
}));

const AvatarGroupText = styled(ParaText)(({ theme }) => ({
  width: 'max-content !important',
  height: 'auto !important',
  margin: 'auto !important',
  transition: 'all .2s linear',
}));

const CustomAvatarGroup = styled(AvatarGroup)(({ theme }) => ({
  position: 'absolute',
  top: '10%',
  right: '6%',
  transform: 'translate(0%, -50%)',
  background: 'transparent',
  backdropFilter: 'blur(5px)',
  color: '#fff',
  padding: '8px',
  borderRadius: '20px',
  transition: 'width 1s linear',
  '& .MuiAvatarGroup-avatar': {
    width: '24px',
    height: '24px',
  },
  '& .avatar-group-text': {
    display: 'none',
    // transform: "scaleX(0)",
  },
  '& .hover-show': {
    display: 'none',
    // transform: "scaleX(0)",
  },
  '&:hover .avatar-group-text': {
    display: 'block',
    // transform: "scaleX(1)",
  },
  '&:hover .hover-show': {
    display: 'block',
    // transform: "scaleX(1)",
  },
}));

const StackedAvatar = styled(Avatar)(({ theme }) => ({
  // width: "24px",
  // height: "24px",
}));

interface galleryCardProps {
  style?: object;
}

// eslint-disable-next-line no-empty-pattern
const GalleryCard: React.FC<galleryCardProps> = ({ style }) => {
  const CardImg = require('assets/AuctionBg.png');
  const userImg = require('assets/user0.png');

  return (
    <Card
      sx={{
        borderRadius: '25px',
        background: '#313646',
        height: '500px',
        width: '330px',
        minHeight: '500px',
        minWidth: '330px',
        position: 'relative',
        overflowX: 'hidden',
        ...style,
      }}
    >
      <CardActionArea style={{ position: 'static', height: '100%' }}>
        <CardMedia
          component="img"
          draggable="false"
          image={CardImg}
          alt="green iguana"
          sx={{
            borderRadius: 'inherit',
          }}
          style={{ height: '100%', width: '100%' }}
          className="no-user-drag"
        />
        <CustomAvatarGroup max={4}>
          <AvatarGroupText
            sx={{ marginRight: '20px !important', opacity: '.64' }}
            className="avatar-group-text"
          >
            Owned By
          </AvatarGroupText>
          <StackedAvatar alt="Remy Sharp" src={userImg} />
          <AvatarGroupText
            sx={{ marginLeft: '10px !important' }}
            className="avatar-group-text"
          >
            @ellie
          </AvatarGroupText>
        </CustomAvatarGroup>
        <CustomAvatarGroup max={6} style={{ top: '20%' }}>
          <AvatarGroupText
            sx={{ marginRight: '20px !important', opacity: '.64' }}
            className="avatar-group-text"
          >
            Split with
          </AvatarGroupText>
          <StackedAvatar className="" alt="Remy Sharp" src={userImg} />
          <StackedAvatar
            className="hover-show"
            alt="Travis Howard"
            src={userImg}
          />
          <StackedAvatar
            className="hover-show"
            alt="Travis Howard"
            src={userImg}
          />
          <StackedAvatar
            className="hover-show"
            alt="Cindy Baker"
            src={userImg}
          />
          <AvatarGroupText
            sx={{ marginLeft: '10px !important' }}
            className="avatar-group-text"
          >
            @john
          </AvatarGroupText>
        </CustomAvatarGroup>
        <CustomCardContent>
          <TitleText>Strong feeling</TitleText>
          <Grid container style={{ marginTop: '1rem' }}>
            <Grid item xs={6} style={{ textAlign: 'left' }}>
              <ParaText
                style={{ fontSize: '0.8rem', margin: '0px', color: '#C1C1C1' }}
              >
                RESERVE PRICE
              </ParaText>
              <SuperScriptStr
                text={'0.11'}
                sup={'ETH'}
                style={{
                  color: '#e5e5e5',
                  fontSize: '1.1rem',
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
              <NormalButton color="transparent">
                <PlayArrow
                  style={{
                    opacity: '0.9',
                    color: '#ffffff',
                    padding: 'unset',
                    fontSize: '1.1rem',
                    marginRight: '5px',
                  }}
                />
                <ParaText style={{ margin: '0px' }}>28.9k</ParaText>
              </NormalButton>
            </Grid>
          </Grid>
        </CustomCardContent>
      </CardActionArea>
    </Card>
  );
};

export default GalleryCard;
